export default __webpack_public_path__ + "static/media/ks1_fun_day.35755f0d.jpg";